// extracted by mini-css-extract-plugin
export default {"home_main":"index_home_main_PFiA7 clearfix","w1000":"index_w1000_ZHKon","left_main":"index_left_main_VbN4U","right_main":"index_right_main_ybM7-"};